module.exports = __webpack_public_path__ + "static/media/noa_kit_back.8a3b5736.jpg";